import 'remixicon/fonts/remixicon.css'
import {setLearnOffCanvasIsActive, setWatchOffCanvasIsActive} from "../../../Features/Misc/navBarSlice";
import {setActiveLearn, setActiveWatch} from "../../../Features/Misc/activeSlice";
import {useDispatch} from "react-redux";
import stripHtml from "../../Components/StripHTML";
import FaveHeart from "../../Components/FaveHeart";
import defaultSleepImage1 from '../../../assets/default-images/default-sleep-image-1.png';
import defaultSleepImage2 from '../../../assets/default-images/default-sleep-image-2.png';
import defaultSleepImage3 from '../../../assets/default-images/default-sleep-image-3.png';
import defaultSleepImage4 from '../../../assets/default-images/default-sleep-image-4.png';
import defaultSleepImage6 from "../../../assets/default-images/default-sleep-image-6.jpg"
import defaultSleepImage7 from "../../../assets/default-images/default-sleep-image-7.jpg"
import defaultSleepImage8 from "../../../assets/default-images/default-sleep-image-8.jpg"
import defaultSleepImage9 from "../../../assets/default-images/default-sleep-image-9.jpg"
import defaultSleepImage10 from "../../../assets/default-images/default-sleep-image-10.jpg"
import React from "react";

export default function LearnCard(props) {

    const dispatch = useDispatch();

    const {
        imgSrc,
        title,
        text,
        vidLink,
        mediaType,
        mediaId
    } = props

    const learnPayload = {
        imgSrc,
        title,
        text,
        vidLink,
        mediaType,
        mediaId
    }

    const learnCardBase = " learnCard  grid grid-rows-24 h-96 rounded-lg text-black hover:opacity-60 transition-opacity duration-300 "

    const defaultImgChoice = [
        defaultSleepImage1,
        defaultSleepImage2,
        defaultSleepImage3,
        defaultSleepImage4,
        defaultSleepImage6,
        defaultSleepImage7,
        defaultSleepImage8,
        defaultSleepImage9,
        defaultSleepImage10
    ];

    const randomImgNumber = Math.floor(Math.random() * 9);
    const imageUrl = imgSrc || defaultImgChoice[randomImgNumber];

    const handleCardClick = React.useCallback(() => {
        dispatch(setLearnOffCanvasIsActive())
        dispatch(setActiveLearn(learnPayload));
    }, [dispatch, learnPayload]);

    return (
        <div className={`pr-4`}>
            <div  className={`${learnCardBase} cursor-pointer  ` } onClick={handleCardClick}>

                <div className="learnCard_image row-start-1 row-end-9  bg-white rounded-t-xl -mb-1 bg-cover no-repeat bg-center grid grid-rows-12 grid-cols-24" style={{backgroundImage: `url(${imageUrl})` }} >
                    <FaveHeart type={"Learn"} mediaId={mediaId} mediaType={mediaType}/>
                </div>

                <div className="learnCard_title row-start-9 row-end-12 text-base w-full bg-white rounded-t-xl pt-2 -mt-1 px-5 font-semibold">{stripHtml(title)}</div>
                <div className="learnCard_text row-start-12 row-end-18 text-sm px-5 py-1 bg-white ">{stripHtml(text.substring(0, 120))}...</div>

                <div className="faveLearnCard_time row-start-18 row-end-20 flex flex-row bg-white items-center px-5 ">
                    {/*<i className="ri-time-line  text-pink-dashboard text-xl mr-2" />*/}
                    {/*<p className={` bg-white  text-sm`}>1h 15min</p>*/}
                </div>

                <div className="faveLearnCard_progress row-start-20 row-end-21 flex justify-between bg-white  px-5 items-center">
                    <div className="h-1 bg-purple-slumber w-full progressBar"></div>
                </div>

                <button className="faveLearnCard_button row-start-21 row-end-24  px-5 bg-white flex items-center cursor-default">
                    <div onClick={() => {dispatch(setLearnOffCanvasIsActive()); dispatch(setActiveLearn(learnPayload))}} className="mr-4 font-medium cursor-pointer  ">Learn</div>
                    <i className="text-gold-accent ri-arrow-right-line text-xl cursor-pointer"></i>
                </button>

                <div className={`faveLearnCard_footer row-start-24 row-end-25 w-full flex flex-col  justify-self-end `}>
                    <div className="h-1/2 bg-white"></div>
                    <div className="h-1/2 bg-gold-accent rounded-b-lg"></div>
                </div>

            </div>
        </div>
    );
}
